import { createLocale } from "./createLocale";

export const nl = createLocale({
  header: {
    title: "Ga wereldwijd. $2 per Short. Elke taal!",
    subtitle: "🔥Betaal alleen voor resultaat – van $0.089 tot $0.009 per seconde🔥",
  },
  steps: {
    uploadVideo: "Video uploaden",
    selectLanguages: "Talen selecteren",
    conversionResult: "Conversie en resultaat",
  },
  upload: {
    dragAndDrop: "Sleep je videobestand hierheen",
    orClickToSelect: "of klik om te selecteren",
    supportedFormats: "Ondersteunde formaten: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maximale bestandsgrootte: 200 MB",
    maxDuration: "• Maximale duur: 30 sec",
    chooseFile: "Bestand kiezen",
    selectedFile: "Geselecteerd bestand:",
    size: "Grootte:",
    fileTypeError: "Selecteer een videobestand",
    fileSizeError: "Bestandsgrootte ({size} MB) overschrijdt de maximale limiet van 200 MB",
    durationError: "Videoduur ({duration} sec) overschrijdt de maximale limiet van 30 sec",
    fileReadError: "Kan videobestand niet lezen. Probeer een ander bestand.",
  },
  languages: {
    sourceAudioLanguage: "Bronaudiotaal",
    targetAudioLanguage: "Doelaudiotaal",
    selectLanguage: "Selecteer taal...",
  },
  conversion: {
    replaceAudio: "Kloon mijn stem",
    uploadVideoAndSelectLanguages: "Upload een video en selecteer talen om door te gaan",
  },
  nav: {
    blog: "Blog",
  },
  footer: {
    privacyPolicy: "Privacybeleid",
    termsOfUse: "Gebruiksvoorwaarden",
  },
  languageOptions: {
    nl: "Nederlands",
  },
});
